/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ maxCps: NonNullable<unknown> }} Error_Nav_Cps_ExceedsInputs */

const en_error_nav_cps_exceeds = /** @type {(inputs: Error_Nav_Cps_ExceedsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`CPS exceeds maximum set rate (${i?.maxCps}).`)
};

const fr_error_nav_cps_exceeds = /** @type {(inputs: Error_Nav_Cps_ExceedsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Le CPS depasse le taux maximal defini (${i?.maxCps}).`)
};

const de_error_nav_cps_exceeds = /** @type {(inputs: Error_Nav_Cps_ExceedsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`CPS überschreitet die maximal eingestellte Rate (${i?.maxCps}).`)
};

const it_error_nav_cps_exceeds = /** @type {(inputs: Error_Nav_Cps_ExceedsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il CPS supera la velocità massima impostata (${i?.maxCps}).`)
};

const ru_error_nav_cps_exceeds = /** @type {(inputs: Error_Nav_Cps_ExceedsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`CPS превышает максимально установленную скорость (${i?.maxCps}).`)
};

const es_error_nav_cps_exceeds = /** @type {(inputs: Error_Nav_Cps_ExceedsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`CPS excede la velocidad máxima establecida (${i?.maxCps}).`)
};

const zh_cn2_error_nav_cps_exceeds = /** @type {(inputs: Error_Nav_Cps_ExceedsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`CPS 超过最大设定值 (${i?.maxCps})。`)
};

const ja_error_nav_cps_exceeds = /** @type {(inputs: Error_Nav_Cps_ExceedsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`CPS が最大設定レート (${i?.maxCps}) を超えています。`)
};

const hi_error_nav_cps_exceeds = /** @type {(inputs: Error_Nav_Cps_ExceedsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`सीपीएस अधिकतम निर्धारित दर (${i?.maxCps}) से अधिक है।`)
};

const pt_pt2_error_nav_cps_exceeds = /** @type {(inputs: Error_Nav_Cps_ExceedsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`CPS excede a taxa máxima definida (${i?.maxCps}).`)
};

/**
* | output |
* | --- |
* | "CPS exceeds maximum set rate ({maxCps})." |
*
* @param {Error_Nav_Cps_ExceedsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_cps_exceeds = /** @type {((inputs: Error_Nav_Cps_ExceedsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Cps_ExceedsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_nav_cps_exceeds(inputs)
	if (locale === "de") return de_error_nav_cps_exceeds(inputs)
	if (locale === "it") return it_error_nav_cps_exceeds(inputs)
	if (locale === "ru") return ru_error_nav_cps_exceeds(inputs)
	if (locale === "es") return es_error_nav_cps_exceeds(inputs)
	if (locale === "zh-CN") return zh_cn2_error_nav_cps_exceeds(inputs)
	if (locale === "ja") return ja_error_nav_cps_exceeds(inputs)
	if (locale === "hi") return hi_error_nav_cps_exceeds(inputs)
	if (locale === "pt-PT") return pt_pt2_error_nav_cps_exceeds(inputs)
	return en_error_nav_cps_exceeds(inputs)
});